import ImageIconPath from "@ingka/ssr-icon/paths/image";

export default ImageIconPath;
